import React from 'react';

interface Props {
  label: string;
  required?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: boolean;
}

export const FormTextarea: React.FC<Props> = ({
  label,
  required,
  placeholder,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="font-18 font-medium text-white">
        {label} {required && <span className="text-[#FF0000]">*</span>}
      </label>

      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={4}
        className={`bg-transparent border rounded-md px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-blue-500
        ${error ? 'border-red-500' : 'border-white/20'}`}
      />
    </div>
  );
};
